// extracted by mini-css-extract-plugin
module.exports = {"secondStepWrapper":"choose-frequency-later-lock_secondStepWrapper__pHNO0"};